import { PropTypes } from "base/react-libs";
import DueDatePicker from "../top-nav/due-date-picker";
import JourneysTaskTable from "./task-table/journeys-task-table";
import JourneysTitleList from "../top-nav/journeys-title-list";
import JourneysBanner from "../top-nav/journeys-banner";

const JourneyDetail = ({
  journey = {},
  selectedDueDate,
  setSelectedDueDate = () => {},
  selectedTask,
  setSelectedTask,
  optionalStateManagementFunction = () => {},
  journeyGroups,
  setSelectedJourneyGroup,
  selectedJourneyGroup,
  journeys,
}) => {
  return (
    <>
      <JourneysBanner journey={journey} />
      <DueDatePicker selectedDueDate={selectedDueDate} setSelectedDueDate={setSelectedDueDate} />
      <JourneysTitleList
        journeyGroups={journeyGroups}
        setSelectedJourneyGroup={setSelectedJourneyGroup}
        selectedJourneyGroup={selectedJourneyGroup}
        journeys={journeys}
        selectedDueDate={selectedDueDate}
      />
      <JourneysTaskTable
        journey={journey}
        selectedTask={selectedTask}
        setSelectedTask={setSelectedTask}
        optionalStateManagementFunction={optionalStateManagementFunction}
      />
    </>
  );
};

JourneyDetail.propTypes = {
  journey: PropTypes.object.isRequired,
  selectedDueDate: PropTypes.number,
  setSelectedDueDate: PropTypes.func,
  selectedTask: PropTypes.object,
  setSelectedTask: PropTypes.func,
  optionalStateManagementFunction: PropTypes.func,
  journeyGroups: PropTypes.array,
  setSelectedJourneyGroup: PropTypes.func,
  selectedJourneyGroup: PropTypes.object,
  journeys: PropTypes.array,
};

export default JourneyDetail;
